import { render } from "./CustomizeHouseSlider.vue?vue&type=template&id=db52bb3c&ts=true&lang=pug"
import script from "./CustomizeHouseSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomizeHouseSlider.vue?vue&type=script&setup=true&lang=ts"

import "./CustomizeHouseSlider.vue?vue&type=style&index=0&id=db52bb3c&lang=scss"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__